import { Alert, Button, Col, Form, Input, Row, Typography, DatePicker, InputNumber } from "antd";
import axios from "axios";
import React, { useState } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import PageTitle from "../page-header/PageHeader";

//Update Currency API REQ
const updateProductCurrency = async (id, values) => {
  try {
    await axios({
      method: "put",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      url: `product-Currency/${id}`,
      data: {
        ...values,
      },
    });
    return "success";
    // return data;
  } catch (error) {
    console.log(error.message);
  }
};

function UpdateProductCurrency() {
  const { Title } = Typography;
  const [form] = Form.useForm();
  const [success, setSuccess] = useState(false);
  const { id } = useParams();

  //Loading Old data from URL
  const location = useLocation();
  const { data } = location.state;

  const Currency = data;
  const [initValues, setInitValues] = useState({
    name: Currency.name,
    symbol: Currency.symbol,
    conversion: Currency.conversion,
    effective_from_date: Currency.effective_from_date ? moment(Currency.effective_from_date) : null,
  });

  const onFinish = (values) => {
    try {
      const payload = {
        ...values,
      };
      // Format date if present
      if (values.effective_from_date) {
        payload.effective_from_date = values.effective_from_date.format('YYYY-MM-DD');
      } else {
        payload.effective_from_date = null;
      }
      updateProductCurrency(id, payload);
      setSuccess(true);
      toast.success("Currency details is updated");
      setInitValues({});
    } catch (error) {
      console.log(error.message);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const isLogged = Boolean(localStorage.getItem("isLogged"));

  if (!isLogged) {
    return <Navigate to={"/auth/login"} replace={true} />;
  }

  return (
    <>
      <Title
        title={`Update Currency/ ${id}`}
        subtitle="Update Currency information"
      />
      <div className="text-center">
        <div className="">
          <Row className="mr-top">
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={14}
              className="border rounded column-design"
            >
              {success && (
                <div>
                  <Alert
                    message={`Currency details updated successfully`}
                    type="success"
                    closable={true}
                    showIcon
                  />
                </div>
              )}
              <Title level={3} className="m-3 text-center">
                Edit Currency Form
              </Title>
              <Form
                initialValues={{
                  ...initValues,
                }}
                form={form}
                className="m-4"
                name="basic"
                labelCol={{
                  span: 8,
                }}
                wrapperCol={{
                  span: 16,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                <Form.Item
                  style={{ marginBottom: "10px" }}
                  fields={[{ name: "Name" }]}
                  label="Name"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please input Currency name!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Symbol"
                  name="symbol"
                  rules={[
                    {
                      required: true,
                      message: "Please input Currency symbol!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Conversion Rate"
                  name="conversion"
                  rules={[
                    {
                      required: true,
                      message: "Please input Conversion rate!",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    step={0.01}
                    precision={4}
                    style={{ width: "100%" }}
                  />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Effective From Date"
                  name="effective_from_date"
                  tooltip="Currency conversion rate will be effective from this date"
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    format="DD-MMM-YYYY"
                    placeholder="Select effective from date (optional)"
                  />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  wrapperCol={{
                    offset: 8,
                    span: 16,
                  }}
                >
                  <Button block type="primary" htmlType="submit" shape="round">
                    Update Now
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}

export default UpdateProductCurrency;
